// This page for SignUp and Login Both. // 1. For Signup need to submit attorney
number and email address which was sent in email to particular attorney
Aftersuccessfully submit application form. // 2. If already signup and attorney
have email and passowrd, then click on Password already registered? link and
enter email and passowrd to Login. // 3. After successfull,it will redirect to
register passowrd and secret question answer and If attorney number and email
wrong in signup, It will redirect to sign in lead page for submit application
first to get attorney number and email. // 4 After successfull login, it will
redirect to application form again to edit or update information.
<template>
  <div class="items-center min-h-screen w-full xl:p-32 md:p-10">
        <div class="md:flex w-full rounded justify-center">
            <div class="hidden xl:w-1/2 md:w-full barley-corn-bg-color-2 py-10 px-5">
                    <div class="flex">
                      <div class="flex-shrink-0">
                        <svg
                          class="h-5 w-5 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </div>
                      <div class="ml-3">
                        <div class="text-sm text-white">
                          <p>
      <b>Attorney Portal Instructions:</b>
      <br>
      <br>Welcome to our Attorney Portal! Your attorney portal comes equipped to manage your account & profile, view members/cases that are assigned to you, 
      and provides the claim portal and authorization request all within one area. 
      <br><br> Step 1: Before you use this portal, 
      you will need to create an account. Please click the link that says “Register Account.”  
      You will be prompted to enter a few key details including: 
      <ul class="list-disc ml-10 mt-2 mb-2">
        <li>Your USL Attorney Number (which is the username that you were previously 
      logging in with)</li>
      <li>Your ZIP (if multiple locations, please use the primary address ZIP code that you originally 
      provided us on your application)</li>
      <li>EIN/SSN Last Four Digits</li>
      </ul> Fill in, then click Proceed.<br><br>
      Step 2: You will be prompted to set up your own Username, Password, and Security Question. Fill in, 
      then click Register.
      <br><br> Step 3: Sign in with the credentials that you just created.
      </p>
                        </div>
                      </div>
                    </div>
                  </div>
            <div class="w-full xl:w-1/2 md:w-full py-10 px-5 md:px-10 bg-white shadow-lg">
              <div class="md:flex w-full">
                <div class="w-full py-3 px-5">
                  <div v-if="isRegistered">
                    <span class="float-right">First time accessing the attorney portal?</span>
                    <br>
                   <a
                              href="javascript:;"
                              v-if="isRegistered"
                              @click="toggleForm()"
                              class="mt-2 cobalt-text-color inline-flex float-right text-xl"
                              >Register Account</a
                            >
                  </div>
                  <div class="flex items-center">
                    <svg
                      class="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
                      ></path>
                    </svg>
                    <div
                      class="text-right text-xl cobalt-text-color"
                      v-if="!isRegistered"
                    >
                      Register Account
                    </div>
                    <div
                      class="text-right text-xl cobalt-text-color"
                      v-if="isRegistered"
                    >
                      Log In
                    </div>
                    
                  </div>

                  <form class="mt-5 space-y-6" @submit.prevent="logIn" novalidate>
                    <div class="rounded-sm">
                      <div class="flex flex-col" v-if="!isRegistered">
                        <text-input
                        id="attorney_number"
                          label="USL Attorney Number"
                          :class="{ 'border-red-400': v$.form.attorney_number.$error }"
                          v-bind:value="form.attorney_number"
                          @blur="form.attorney_number = form.attorney_number?.trim(); v$.form.attorney_number.$touch()"
                          v-on:keyup="form.attorney_number = $event.target['value']"
                        ></text-input>
                        <div
                          class="text-red-600 mt-1 text-sm"
                          v-for="(error, index) in v$.form.attorney_number.$errors"
                          :key="index"
                        >
                          <div v-if="error.$validator == 'required'">
                            {{ error.$message }}
                          </div>
                        </div>
                      </div>
                      <div class="flex flex-col mt-2" v-if="!isRegistered">
                        <text-input
                        id="zip"
                          label="ZIP (Primary address)"
                          :class="{ 'border-red-400': v$.form.zip.$error }"
                          v-bind:value="form.zip"
                          @blur="form.zip = form.zip?.trim(); v$.form.zip.$touch()"
                          v-on:keyup="form.zip = $event.target['value']"
                        ></text-input>
                        <div
                          class="text-red-600 mt-1 text-sm"
                          v-for="(error, index) in v$.form.zip.$errors"
                          :key="index"
                        >
                          <div v-if="error.$validator == 'required'">
                            {{ error.$message }}
                          </div>
                        </div>
                      </div>
                      <div class="flex flex-col mt-2" v-if="!isRegistered">
                        <text-input
                        id="last_4_ssn"
                          label="EIN/SSN (last four digits)"
                          :class="{ 'border-red-400': v$.form.last_4_ssn.$error }"
                          v-bind:value="form.last_4_ssn"
                          @blur="form.last_4_ssn = form.last_4_ssn?.trim(); v$.form.last_4_ssn.$touch()"
                          v-on:keyup="form.last_4_ssn = $event.target['value']"
                        ></text-input>
                        <div
                          class="text-red-600 mt-1 text-sm"
                          v-for="(error, index) in v$.form.last_4_ssn.$errors"
                          :key="index"
                        >
                          <div v-if="error.$validator == 'required'">
                            {{ error.$message }}
                          </div>
                        </div>
                        <div class="text-xs">
                          <a
                            href="javascript:;"
                            @click="toggleForm()"
                            class="float-right mt-2 cobalt-text-color inline-flex"
                            >Account already registered?</a
                          >
                        </div>
                      </div>
                      <div class="flex flex-col" v-if="isRegistered">
                        <text-input
                         id="username"
                          label="Username"
                          autocomplete="username"
                          :class="{ 'border-red-400': v$.form.username.$error }"
                          v-bind:value="form.username"
                          @blur="form.username = form.username?.trim(); v$.form.username.$touch()"
                          v-on:input="form.username = $event"
                          v-on:keyup="form.username = $event.target['value']"
                        ></text-input>
                        <div
                          class="text-red-600 mt-1 text-sm"
                          v-for="(error, index) in v$.form.username.$errors"
                          :key="index"
                        >
                          <div v-if="error.$validator == 'required'">
                            {{ error.$message }}
                          </div>
                        </div>
                      </div>
                      <div class="flex flex-col mt-2" v-if="isRegistered">
                        <text-input
                        id="password"
                          label="Password"
                          autocomplete="current-password"
                          :type="show ? 'password' : 'text'"
                          showIcon="true"
                          showIcon1="true"
                          @showHide="show = !show"
                          @keydown.space.prevent
                          :class="{ 'border-red-400': v$.form.password.$error }"
                          v-bind:value="form.password"
                          v-on:input="form.password = $event"
                          v-on:keyup="form.password = $event.target['value']"
                        ></text-input>
                        <div
                          class="text-red-600 mt-1 text-sm"
                          v-for="(error, index) in v$.form.password.$errors"
                          :key="index"
                        >
                          <div v-if="error.$validator == 'required'">
                            {{ error.$message }}
                          </div>
                          <!-- <div v-if="error.$validator == 'password'">
                            {{ error.$message }}
                          </div> -->
                        </div>
                        <div class="text-xs w-full">
                          <div class="w-full text-right">
                            <router-link
                              to="/forgot-password"
                              v-if="isRegistered"
                              class="mt-2 cobalt-text-color inline-flex"
                              >Forgot Password?</router-link
                            >
                          </div>
                          <div class="w-full text-right">
                            <router-link
                              to="/forgot-username"
                              v-if="isRegistered"
                              class="mt-2 cobalt-text-color inline-flex"
                              >Forgot Username?</router-link
                            >
                          </div>
                          <a
                            href="javascript:;"
                            v-if="!isRegistered"
                            @click="toggleForm()"
                            class="mt-2 cobalt-text-color inline-flex"
                            >Password already registered?</a
                          >
                        </div>
                      </div>
                    </div>
                    <div>
                      <button
                        id="signin"
                        type="submit"
                        class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-50"
                        aria-required="true"
                      >
                        <span class="absolute left-0 inset-y-0 flex items-center pl-3">
                          <svg
                            class="w-6 h-6"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                            ></path>
                          </svg>
                        </span>
                        <span v-if="isRegistered">Log In</span>
                        <span v-if="!isRegistered">Proceed</span>
                      </button>
                    </div>
                    <div class="text-primary text-center">
                      Trouble logging in? Please contact attorneyinfo@uslegalservices.net
                    </div>
                  </form>
                </div>
              </div>
            </div>
           
        </div>
  </div>
</template>
<script>
import TextInput from "../Layout/Form/TextInput.vue";
// import { mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
// import { helpers } from "vuelidate/lib/validators";
// const email = helpers.regex("email",/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/);
export default {
  name: "LogIn",
  components: {
    TextInput,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data: function () {
    return {
      show: true,
      isRegistered: Boolean,
      form: { zip: "", username: "", password: "", attorney_number: "" },
    };
  },
  validations() {
    if (this.isRegistered) {
      return {
        form: {
          username: {
            required,
          },
          password: {
            required,
          },
        },
      };
    } else {
      return {
        form: {
          zip: {
            required,
          },
          attorney_number: {
            required,
          },
          last_4_ssn: {
            required,
          },
        },
      };
    }
  },
  created() {
    this.$store.watch(
      () => this.$store.state.att_user,
      (value) => {
        console.log(value);
        if (value?.data != undefined) {
          localStorage.setItem("att_data", JSON.stringify(value));
          if (value.data["password"] != null && value.data["password"] != "") {
            this.$router.push("/home");
          } else {
            this.$toast.success("Please set your login info");
            this.$router.push("/register");
          }
        }
      }
    );
    this.$store.watch(
      () => this.$store.state.errors,
      (value) => {
        console.log(value);
        if (value[0] != undefined) {
          if (value[0].message == "No records found") {
            this.$toast.error("Attorney not found");
          } else if (value[0].message == "Password already registered") {
            this.$toast.error(value[0].message);
            this.isRegistered = true;
          } else {
            this.$toast.error("Incorrect password. Try again");
          }
        }else{
          this.$toast.error("Something went wrong, please Try again");
        }
      }
    );
  },
  mounted() {
    this.isRegistered = true;
  },
  methods: {
    logIn: function () {
      const usernameEl = document.getElementById("username");
      const passwordEl = document.getElementById("password");
      if (!this.form.username && usernameEl?.value) this.form.username = usernameEl.value;
      if (!this.form.password && passwordEl?.value) this.form.password = passwordEl.value;

      this.v$.form.$touch(this.v$.form.errors);
      console.log(this.v$.form);
      if (this.v$.form.$pending || this.v$.form.$error) return;
      this.form.is_registered=this.isRegistered;
      this.$store.dispatch("loginAttorney", this.form);
    },
    toggleForm: function () {
      this.v$.$reset();
      this.form.password = null;
      this.form.attorney_number = null;
      this.isRegistered = !this.isRegistered;
    },
  },
};
</script>
